import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { SHAPE_COMPONENT, SHAPE_FACTSHEET_BLUEPRINT } from '../../shapes'
import Icon from '../../../Icon'
import './styles.scss'
import SelectTracked from '../../../FormTracked/SelectTracked'
import { trackingEvent } from '../../../../../constants'
import { getTrackingFactLabel } from '../../helper'

class AttributeSingleSelect extends PureComponent {
  state = {
    options: [],
    valid: true,
    required: false,
    selectedOption: null
  }

  componentDidMount () {
    const options = this.buildOptions()
    this.updateState(options)
  }

  componentDidUpdate (prevProps) {
    let options = this.state.options
    let hasPropsChanged = false
    if (prevProps.blueprint !== this.props.blueprint) {
      options = this.buildOptions()
      hasPropsChanged = true
    }
    if (prevProps.data !== this.props.data) {
      hasPropsChanged = true
    }
    if (hasPropsChanged) {
      this.updateState(options)
    }
  }

  updateState (options) {
    const factDefId = this.props.parentBlueprint.id
    const required = !!this.props.blueprint.required
    const selectedOption = this.getSelectedOption(options)
    const valid = !(required && selectedOption === null)
    if (selectedOption === null) {
      this.setDefaultOption(options)
    }
    if (
      valid !== this.state.valid
      || required !== this.state.required
      || this.state.selectedOption !== selectedOption
    ) {
      this.setState({ valid, required, selectedOption })
      if (selectedOption) {
        this.props.putValidationStatus(
          factDefId, this.props.factInstanceKey, selectedOption.value, valid
        )
        return
      }
      const firstOptionWithValue = options.find(option => option.value !== '')
      this.props.putValidationStatus(
        factDefId, this.props.factInstanceKey, firstOptionWithValue.value, valid
      )
    }
  }

  onSelectChange = (e) => {
    const selectedOption = this.getSelectedOption(this.state.options)
    if (e.target.value === '') {
      if (selectedOption) {
        this.props.deleteAttribute(
          this.props.parentBlueprint.id,
          this.props.factInstanceKey,
          selectedOption.value
        )
      }
      return
    }
    if (selectedOption && selectedOption.value !== e.target.value) {
      this.props.deleteAttribute(
        this.props.parentBlueprint.id,
        this.props.factInstanceKey,
        selectedOption.value
      )
    }
    this.props.putAttribute(
      this.props.parentBlueprint.id,
      this.props.factInstanceKey,
      e.target.value,
      { attributeDefId: e.target.value }
    )
  }

  getSelectedOption (options) {
    if (!this.props.data.hasOwnProperty('attributes')) {
      return null
    }
    for (let option of options) {
      if (this.props.data.attributes.hasOwnProperty(option.value)) {
        return option
      }
    }
    return null
  }

  setDefaultOption (options) {
    if (options.length > 0 && options[0].value !== '') {
      this.props.putAttribute(
        this.props.parentBlueprint.id,
        this.props.factInstanceKey,
        this.props.blueprint.options[0].id,
        {
          attributeDefId: options[0].value
        }
      )
    }
  }

  buildOptions () {
    const options = this.props.blueprint.options.map((option) => {
      let label = option.label
      if (!option.hasOwnProperty('label') && option.hasOwnProperty('id')) {
        const attribute = this.props.factsheetBlueprint.factTree.attributes[option.id]
        label = attribute.label
      }
      return {
        label: label,
        value: option.hasOwnProperty('id') ? option.id : ''
      }
    })
    this.setState({ options })
    return options
  }

  render () {
    const label = this.props.blueprint.label
    const selectedOption = this.state.selectedOption
    if (this.props.collapsed) {
      if (selectedOption === null) {
        return null
      }
      return <div className={'attribute-single-select-collapsed'}>{label}: {selectedOption.label}</div>
    }
    const definition = this.props.blueprint.definition
    const showActions = !!definition
    return (
      <div className={'attribute-single-select'}>
        <div className={'attribute-single-select-header'}>
          <label>{label} {this.state.required ? '*' : ''}</label>
          {
            showActions && (
              <div className={'attribute-single-select-actions'}>
                {definition && <Icon type={'how'} tooltip={definition}/>}
              </div>
            )
          }
        </div>
        <SelectTracked
          eventName={trackingEvent.editValue}
          eventOpts={
            {
              name: getTrackingFactLabel(
                this.props.parentBlueprint, this.props.factsheetBlueprint)
            }
          }
          onChange={this.onSelectChange}
          options={this.state.options}
          valid={this.state.valid}
          selected={selectedOption === null ? null : selectedOption.value}/>
      </div>
    )
  }
}

AttributeSingleSelect.propTypes = {
  blueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  parentBlueprint: PropTypes.shape(SHAPE_COMPONENT).isRequired,
  factsheetBlueprint: PropTypes.shape(SHAPE_FACTSHEET_BLUEPRINT).isRequired,
  factInstanceKey: PropTypes.number.isRequired,
  putAttribute: PropTypes.func.isRequired,
  deleteAttribute: PropTypes.func.isRequired,
  putValidationStatus: PropTypes.func.isRequired,
  collapsed: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired, // factInstance
}
export default AttributeSingleSelect
